// todo move other api text constants here
const api = {
  reports: '/api/report/reports',
  publishers: '/api/report/publist',
  documents: '/api/documents/list'
};

export default api;


// WEBPACK FOOTER //
// ./src/common/constants/api.js